<template>
  <vs-popup
    ref="feedbackModal"
    :title="$t('Title')"
    :active.sync="showModal">
    <transition name="zoom-fade">
      <div v-if="showModal">

        <vs-input
          v-model="model.subject"
          type="text"
          class="w-full required"
          :name="$t('Subject')"
          :label="$t('Subject')"
          v-validate="'required|max:100'"
          :danger="errors.has($t('Subject'))"
          :danger-text="errors.first($t('Subject'))"
          val-icon-danger="clear"
        />

        <contact-modal-comments
            ref="comments"
            v-model="model.message"
            class="mt-base w-full"
          />

        <upload-file
            ref="uploadFile"
            class="mt-base"
            minimal
            :accept-ext="[
              '.png', '.jpg', '.jpeg', '.gif',
              '.mp4','.wmv', '.avi', '.mkv', '.webm', '.flv',
              '.pdf', '.txt', '.csv', '.doc', '.docx', '.xls', '.xlsx'
            ]"
            :max-file-size="20480"
            @file="(file) => this.model.attachment = file"
          />

        <upload-loader
          v-show="saving"
          :text="$t('$General.Saving')"/>

        <vs-divider/>

        <div
          class="flex justify-end">
          <vs-button
            v-avoid-key-tab-event
            color="primary"
            @click="sendMessage">
            {{ $t('$General.Submit') }}
          </vs-button>
        </div>
      </div>
    </transition>
  </vs-popup>
</template>

<script>
// Components
import UploadFile from '@/views/modules/_components/UploadFile.vue';
import ContactModalComments from '@/layouts/components/contact/TheContactModalComments.vue';

import UploadLoader from '@/views/modules/_components/UploadLoader.vue';

// Services
import userService from '@/api/modules/user.service';

/**
 * Feedback button
 *
 * @module layouts/components/TheContactModal.vue
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  name: 'TheContactModal',
  i18n: {
    messages: {
      en: {
        Title: 'Contact us',
        Subject: 'Subject',
        $SentNotification: {
          Title: 'Message sent',
          Msg: 'Your message has been submitted. We will contact you via email.',
        },
      },
    },
  },
  components: {
    ContactModalComments,
    UploadFile,
    UploadLoader,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showModal: this.value,
      model: {
        subject: '',
        message: '',
        attachment: null,
      },
      saving: false,
    };
  },
  watch: {
    value(value) {
      this.showModal = value;
    },
    showModal(value) {
      this.model = {
        subject: '',
        message: '',
        attachment: null,
      };

      this.$emit('input', value);
    },
  },
  methods: {
    async sendMessage() {
      const formIsValid = await this.$validator.validateAll();
      const commentsValid = await this.$refs.comments.$validator.validateAll();
      const uploadValid = await this.$refs.uploadFile.$validator.validateAll();

      if (formIsValid && commentsValid && uploadValid) {
        try {
          this.saving = true;
          const formData = new FormData();
          formData.append('subject', this.model.subject);
          formData.append('message', this.model.message);
          if (this.model.attachment) {
            formData.append('attachment', this.model.attachment);
          }
          await userService.sendContactForm(formData);
          this.saving = false;

          this.$showSuccessActionNotification({
            title: this.$t('$SentNotification.Title'),
            text: this.$t('$SentNotification.Msg'),
          });

          this.showModal = false;
        } catch (e) {
          this.saving = false;
          this.showModal = false;
        }
      }
    },
  },
};
</script>
